import React, { useState } from 'react';
import androidIcon from '../../icons/androidIcon.svg';
import appleIcon from '../../icons/appleIcon.svg';
import logo from './assets/logo.png';
// SVG icons from the old header module
import { ReactComponent as MenuIcon } from '../../modules/header/images/menu.svg';
import { ReactComponent as CloseIcon } from '../../modules/header/images/close.svg';

const NAV_ITEMS = [
  { label: 'Conheça', href: '#conheca' },
  { label: 'Estacionamento', href: '#estacionamento' },
  { label: 'Relacionamento', href: '#relacionamento' },
  { label: 'Sou lojista', href: '#sou-lojista' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const handleNavClick = (e, href) => {
    e.preventDefault();

    // Close mobile menu if open
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }

    // Get the target element
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Get header height for offset
      const headerHeight = 70;

      // Calculate target position with offset
      const targetPosition = targetElement.offsetTop - headerHeight; // 20px extra padding

      // Smooth scroll to target with offset
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      {/* HEADER */}
      <header
        className={`fixed lg:relative top-0 left-0 rounded-b-3xl w-full lg:max-w-[1300px] px-5 lg:mx-auto bg-white lg:bg-transparent z-40 shadow-md lg:shadow-none flex flex-col lg:flex-row transition-all duration-300 ${
          isMenuOpen ? 'h-[390px]' : 'h-[75px]'
        }`}
      >
        {/* Top bar */}
        <div className="flex items-center justify-between py-5 w-full">
          <img src={logo} alt="Multi Logo" className="h-7" width={126} height={28} />

          {/* Desktop download button */}
          <button className="group bg-[#014B35] text-white rounded-3xl px-8 py-4 text-sm font-semibold cursor-pointer relative overflow-hidden whitespace-nowrap transition-all duration-300 hidden lg:block hover:px-16">
            <span className="group-hover:opacity-0 transition-opacity duration-300 inline-block">Baixar o App</span>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 gap-10">
              <a
                href="https://play.google.com/store/apps/details?id=br.com.multiplan.mind.multishopping&hl=pt_BR&gl=US&pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex items-center justify-center gap-2 text-xs font-semibold">
                  <img src={androidIcon} alt="Android" className="w-4 filter invert brightness-0" />
                  <span>Android</span>
                </div>
              </a>
              <a
                href="https://apps.apple.com/br/app/multi-promo%C3%A7%C3%B5es-dos-shoppings/id1459566420"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex items-center gap-2 text-xs font-semibold">
                  <img src={appleIcon} alt="iOS" className="w-4 filter invert brightness-0" />
                  <span>iPhone</span>
                </div>
              </a>
            </div>
          </button>

          {/* Hamburger menu */}
          <button className="lg:hidden" onClick={toggleMenu} aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}>
            {isMenuOpen ? <CloseIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile expandable section */}
        <div className={`lg:hidden w-full overflow-hidden transform transition-transform duration-300 origin-top`}>
          <nav className="flex flex-col divide-y divide-[#e5e5e5]">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="py-4 font-semibold text-base px-2"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="py-5 px-2">
            <a
              href="https://link.meumulti.com.br/jivm/3x40umvm"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-[#014B35] text-white rounded-full px-8 py-4 w-full flex justify-center font-semibold text-sm"
            >
              Baixar o App
            </a>
          </div>
        </div>

        {/* Desktop centred navigation (pill) */}
        <nav className="hidden lg:flex fixed left-1/2 top-3 -translate-x-1/2 bg-white/80 rounded-full px-10 py-4 gap-10 text-sm font-semibold shadow-sm z-40 w-[max-content]">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="hover:text-[#014B35] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </header>
    </>
  );
};

export default Header;
